module.exports = __webpack_public_path__ + "static/works-cybertalks-61eea1dba9ec6342e03841a9c2e99ec8.jpg";